/*
Everything in this file is subject to change, and mostly handles "slow moving
data" that doesn't exist in the api yet.  Plan to eventually remove the majority
of this and rely soley on the api for information.
*/

export const imgFileTypes = [
  "ai",
  "gif",
  "png",
  "webp",
  "avif",
  "bmp",
  "djvu",
  "ps",
  "ept",
  "eps",
  "eps3",
  "fbx",
  "flif",
  "gif",
  "glb",
  "gltf",
  "heif",
  "heic",
  "ico",
  "indd",
  "jpg",
  "jpe",
  "jpeg",
  "jp2",
  "wdp",
  "jxr",
  "hdp",
  "pdf",
  "png",
  "psd",
  "arw",
  "cr2",
  "svg",
  "tga",
  "tif",
  "tiff",
  "usdz",
  "webp",
];

export const stateNames = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  AS: "American Samoa",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District of Columbia",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  CM: "Northern Mariana Islands",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  TT: "Trust Territories",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  VI: "Virgin Islands",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

const nonUsStateCodes = ["AA", "AE", "AP", "AS", "FM", "MH", "MP", "PW"];
export const usStatesFilter = (opt) =>
  opt.country === "USA" && !nonUsStateCodes.includes(opt.code);

export const countryNames = {
  USA: "United States",
  CAN: "Canada",
  HK: "Hong Kong",
  UK: "United Kingdom",
};
